// Copyright (c) 2025 Deere & Company

import RgaSelectedMassUpdateList, {getDefaultState as getRgaSelectedMassUpdateList} from '../state/rga-selected-mass-update-list';
import actions from '../../actions-list';

const setRgaSelectedMassUpdate = (state, action) =>
    RgaSelectedMassUpdateList.update(state, {
        $set: action.rgaList
    });

export default (state = getRgaSelectedMassUpdateList(), action) => {

    const actionTypes = {
        [actions.SET_SELECTED_RGA_LIST_MASS_UPDATE]: setRgaSelectedMassUpdate
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/rga-selected-mass-update.js